import { stripTrailingSlashes } from '@/lib/path-utils';

/** Paths that must work without login (invite acceptance, 2fa reset, etc.). */
export const PUBLIC_APP_PATH_PREFIXES = ['/admin-invite', '/2fa'] as const;

export function isPublicAppPath(pathname: string | null | undefined): boolean {
  const path = stripTrailingSlashes(pathname);
  if (!path) return false;
  return PUBLIC_APP_PATH_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`)
  );
}

/** Public auth & onboarding routes where notifications / messages must not be fetched. */
export function isPublicAuthRoute(pathname: string | null | undefined): boolean {
  const raw = stripTrailingSlashes(pathname);
  if (!raw) return false;
  const path = raw.split('?')[0];

  return (
    path === '/login' ||
    path.startsWith('/login/') ||
    path === '/register' ||
    path.startsWith('/register/') ||
    path === '/signup' ||
    path.startsWith('/signup/') ||
    path === '/forgot-password' ||
    path.startsWith('/forgot-password/') ||
    path === '/reset-password' ||
    path.startsWith('/reset-password/') ||
    path === '/setup-password' ||
    path.startsWith('/setup-password/') ||
    path === '/verify-email' ||
    path.startsWith('/verify-email/') ||
    path === '/scanner-login'
  );
}

/** Public browser pages (marketing, public events, docs, auth) that should never trigger session-expired redirects. */
export function isPublicBrowserPath(pathname?: string | null | undefined): boolean {
  const target = pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '');
  const raw = stripTrailingSlashes(target);
  if (!raw) return false;
  const path = raw.split('?')[0];

  if (isPublicAuthRoute(path)) return true;

  return (
    path === '' ||
    path === '/' ||
    path.startsWith('/events') ||
    path.startsWith('/host-events') ||
    path.startsWith('/pricing') ||
    path.startsWith('/participate') ||
    path.startsWith('/quiz') ||
    path.startsWith('/guides') ||
    path.startsWith('/articles') ||
    path.startsWith('/resources') ||
    path.startsWith('/developers') ||
    path.startsWith('/privacy') ||
    path.startsWith('/terms') ||
    path.startsWith('/f/') ||
    path === '/f' ||
    path.startsWith('/help') ||
    path.startsWith('/faq') ||
    path.startsWith('/about') ||
    path.startsWith('/contact') ||
    path.startsWith('/solutions') ||
    path.startsWith('/maintenance')
  );
}
